import { FC } from "react";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/shadcn/ui/form";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/shadcn/ui/select";
import { Input } from "@/components/shadcn/ui/input";
import { useFormContext } from "react-hook-form";

interface TContactFormPhoneProps {}

const ContactFormPhone: FC<TContactFormPhoneProps> = (props: TContactFormPhoneProps) => {
  const { control } = useFormContext();

  return (
    <div className='flex items-end'>
      <div>
        <FormField
          name='indicatif'
          control={control}
          render={({ field }) => (
            <FormItem>
              <FormLabel>Indicatif</FormLabel>
              <FormControl>
                <Select value={field.value} onValueChange={field.onChange}>
                  <SelectTrigger className='w-[180px] h-9'>
                    <SelectValue placeholder='Indicatif' />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectGroup>
                      <SelectItem value='+596'>+596</SelectItem>
                      <SelectItem value='+33'>+33</SelectItem>
                    </SelectGroup>
                  </SelectContent>
                </Select>
              </FormControl>
            </FormItem>
          )}
        />
      </div>
      <div className='flex-1'>
        <FormField
          name='telephone'
          control={control}
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                <span className='flex items-center'>
                  <span className='mr-4'>Téléphone</span>
                  <span>
                    <FormMessage />
                  </span>
                </span>
              </FormLabel>
              <FormControl>
                <Input {...field} placeholder='' type='tel' autoComplete='tel' />
              </FormControl>
            </FormItem>
          )}
        />
      </div>
    </div>
  );
};

export default ContactFormPhone;
